
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","id":"Accounting-Bill--Streamline-Streamline--3.0.svg","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Accounting Bill Streamline Icon: https://streamlinehq.com')]),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","d":"M21.75 4.5H2.25A1.5 1.5 0 0 0 0.75 6v12a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5 -1.5V6a1.5 1.5 0 0 0 -1.5 -1.5Z","stroke-width":"1.5"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","d":"M12 15a3 3 0 1 0 0 -6 3 3 0 0 0 0 6Z","stroke-width":"1.5"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M4.5 8.625a0.375 0.375 0 1 1 0 -0.75","stroke-width":"1.5"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M4.5 8.625a0.375 0.375 0 1 0 0 -0.75","stroke-width":"1.5"}}),_c('g',[_c('path',{attrs:{"stroke":"currentColor","d":"M19.5 16.125a0.375 0.375 0 0 1 0 -0.75","stroke-width":"1.5"}}),_c('path',{attrs:{"stroke":"currentColor","d":"M19.5 16.125a0.375 0.375 0 0 0 0 -0.75","stroke-width":"1.5"}})])])
          )
        }
      }
    